module.exports = __webpack_public_path__ + "img/ico_freecoins_5star@2x.cbab4513.png";